export default __webpack_public_path__ + "static/media/poster.8cce6892.webp";